import React from "react";
import PropTypes from "prop-types";

const TableData = (props) => {
	let classNames = props.responsive ? 'u-display:none@to:viewport-9 ' : '';
	classNames = 'c-table-row__data ' + classNames;

	if (props.classNames)
		classNames += props.classNames;

	return (<td key={props.key} className={classNames} style={props.style}>
		{props.children}
	</td>);
};

TableData.propTypes = {
	children: PropTypes.node,
	responsive: PropTypes.bool,
	classNames: PropTypes.string,
	width: PropTypes.string,
	style: PropTypes.string,
	key: PropTypes.string
};

export default TableData;
